// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"15db727c","686":"6037d5fa","701":"f9ec11f0","916":"895f75ee"}[chunkId] + ".chunk.css";
};